export default __webpack_public_path__ + "a67fbbdcf258fd8cced3e209e6df63f0.png";